import React, { useEffect } from "react";
import { Text } from "@chakra-ui/react";
import {
  Link,
  Heading,
  Center,
} from "@chakra-ui/react";
import { theme } from "@chakra-ui/react";
import styled from "@emotion/styled";

const StyledText = styled(Text)`
  a {
    color: ${() => theme.colors.blue[400]};
  }
`;

const SubscribeTile = ({
  tweet,
  utmSource = "",
}) => {

  return (
    <Link
      as="a"
      href={"https://tweethunter.io?" + (utmSource ? "utm_source=" + utmSource : "")}
      target="_blank"
    >
      <Center key={tweet.data.id} minW="250px"
        bg="th-dark"
        rounded="lg"
        // p={2} 
        boxShadow="rgba(100, 100, 111, 0.05) 0px 2px 19px 0px;"
        h="150px"
        p={10}
        color="white"
        flexDir="column"
        textAlign="center"
      >
        <Heading fontSize={"xl"}>Grow your personal brand on X</Heading>
        <Text mt={2}>Try Tweet Hunter for free for a full week.</Text>
      </Center>
    </Link>
  );
};

export default SubscribeTile;
